import React, { FC } from "react"
import { ColumnProps, ColumnViewport } from "./Columns.types"

enum Breakpoint {
    mobile = "mobile",
    tablet = "tablet",
    desktop = "desktop",
    widescreen = "widescreen",
}

const Column: FC<ColumnProps> = ({
    size,
    viewports,
    offset,
    children,
    className,
    ...htmlProps
}: ColumnProps) => {
    let klass = `zb-column-is-${size}`

    if (viewports) {
        for (const k in viewports) {
            const val = viewports[k as Breakpoint]
            if (!val) continue

            let size
            let offset
            if (Object.prototype.hasOwnProperty.call(val, "offset")) {
                size = (val as ColumnViewport).size
                offset = (val as ColumnViewport).offset
            } else {
                size = val as number
            }

            klass += ` zb-column-is-${k}-${size}`

            if (offset) klass += ` zb-column-is-${k}-offset-${offset}`
        }
    }

    if (offset) klass += ` zb-column-is-offset-${offset}`

    klass += className ? ` ${className}` : ""
    return (
        <div className={klass} {...htmlProps}>
            {children}
        </div>
    )
}

export default Column
